import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import Loader from '../../../components/loader/loader'

const Layouts = () => {
    const token = localStorage.getItem('token')
    const navigate = useNavigate()
    useEffect(()=>{
if(token){
    navigate('/dashboard')
}
else{
    navigate('/login')
}
    },[])
  return (
    <div><Loader /></div>
  )
}

export default Layouts